// src/components/Header.jsx - FULL VERSION WITH DEBUGGING
import React from 'react';
import { Wallet } from 'lucide-react';

export const Header = ({ 
  account, 
  isConnected, 
  connectWallet, 
  disconnect, 
  stats 
}) => {
  
  // Check if MetaMask is installed
  const isMetaMaskInstalled = typeof window !== 'undefined' && window.ethereum && window.ethereum.isMetaMask;
  const isWalletAvailable = typeof window !== 'undefined' && window.ethereum;
  
  const handleConnect = async () => {
    console.log('=== CONNECT WALLET DEBUG ===');
    console.log('1. Button clicked');
    console.log('2. connectWallet function exists:', typeof connectWallet === 'function');
    console.log('3. window.ethereum exists:', !!window.ethereum);
    console.log('4. MetaMask installed:', isMetaMaskInstalled);
    console.log('5. Any wallet available:', isWalletAvailable);
    
    if (!isWalletAvailable) {
      console.error('No wallet detected! Please install MetaMask or another Web3 wallet.');
      alert('Please install MetaMask or another Web3 wallet!');
      return;
    }
    
    if (typeof connectWallet !== 'function') {
      console.error('connectWallet is not a function!', connectWallet);
      alert('Wallet connection error. Please refresh the page.');
      return;
    }
    
    try {
      console.log('6. Calling connectWallet()...');
      await connectWallet();
      console.log('7. connectWallet call completed successfully');
    } catch (error) {
      console.error('8. Error in connectWallet:', error);
      console.error('Error message:', error.message);
      console.error('Error code:', error.code);
    }
  };
  
  const handleDisconnect = () => {
    console.log('=== DISCONNECT DEBUG ===');
    console.log('Disconnecting...');
    disconnect();
    console.log('Disconnect called');
  };
  
  return (
    <header className="relative border-b-4 border-white bg-black p-4">
            
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8 relative z-10 mt-6">
        {/* Logo with drop shadow */}
        <div className="relative">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black m-0 tracking-tight text-white font-mono"
              style={{ textShadow: '4px 4px 0 #FF0066' }}>
            DUNK POGE
          </h1>
          
          {/* ON-CHAIN Badge */}
          <div className="absolute -top-3 -right-6 bg-green-400 text-black px-3 py-1 font-black border-2 border-black -rotate-12 shadow-[2px_2px_0_0_#000] text-xs uppercase">
            ON-CHAIN
          </div>
        </div>
        
        {/* Wallet Section */}
        <div className="flex flex-wrap items-center justify-end gap-4 w-full md:w-auto">
          {!isConnected ? (
            !isWalletAvailable ? (
              // No wallet installed
              <a 
                href="https://metamask.io/download/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-yellow-400 text-black font-black px-6 py-3 border-4 border-white flex items-center gap-2 text-sm uppercase font-mono shadow-[6px_6px_0_0_#00ff00] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[8px_8px_0_0_#00ff00] transition-all duration-200 ml-auto"
              >
                <Wallet size={20} />
                <span className="hidden sm:inline">INSTALL METAMASK</span>
              </a>
            ) : (
              // Wallet available but not connected
              <button 
                onClick={handleConnect}
                className="bg-white text-black font-black px-6 py-3 border-4 border-white flex items-center gap-2 text-sm uppercase font-mono shadow-[6px_6px_0_0_#00ff00] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[8px_8px_0_0_#00ff00] transition-all duration-200 ml-auto active:scale-95"
              >
                <Wallet size={20} />
                <span className="hidden sm:inline">CONNECT WALLET</span>
              </button>
            )
          ) : (
            // Connected state
            <div className="flex flex-wrap items-center gap-4 ml-auto">
              {/* Connected Address with Network Badge */}
              <div className="flex flex-col items-end gap-2">
                <div className="bg-blue-500 text-white px-5 py-3 border-4 border-white font-black text-sm font-mono min-w-[120px] text-center shadow-[4px_4px_0_0_rgba(255,255,255,0.8)]">
                  <div className="truncate max-w-[120px] text-xs animate-pulse">
                    {account}
                  </div>
                </div>
              </div>
              
              {/* Disconnect Button */}
              <button 
                onClick={handleDisconnect}
                className="bg-red-500 text-white font-black px-6 py-3 border-4 border-white text-sm uppercase font-mono tracking-wider whitespace-nowrap shadow-[4px_4px_0_0_rgba(255,255,255,0.8)] hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[6px_6px_0_0_rgba(255,255,255,0.8)] transition-all duration-200 active:scale-95"
              >
                DISCONNECT
              </button>
            </div>
          )}
        </div>
        {/* STATS BAR*/}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 -rotate-2 bg-green-400 text-black px-8 py-2 border-4 border-black flex gap-6 font-black text-sm uppercase z-20 whitespace-nowrap shadow-[4px_4px_0_0_#000]">
        <span>{stats.totalSupply}/10,000 MINTED</span>
        <span className="border-l-2 border-black pl-6">
          {stats.remaining} LEFT
        </span>
        <span className="border-l-2 border-black pl-6">
          {stats.price} ETH
        </span>
      </div>

      </div>
    </header>
  );
};